const initialState = {
    statusShow: false,
    loader_modal: false,
    orderDescription: '',
    gratuity: 0,

};
const modalEditOrderDescGratuity = (state = initialState, action) => {
    switch (action.type) {
        case "OPEN_MODAL_EDIT_DESC_GRATUITY":
            return {...state, statusShow: true};
        case "CLOSE_MODAL_EDIT_DESC_GRATUITY":
            return {...initialState, statusShow: false};
        case "TOGGLE_LOADER_MODAL_EDIT_ORDER_DESC_GRATUITY":
            return {...state, loader_modal: action.status};
        case "CHANGE_ORDER_DESC_GRATUITY":
            return {...state, orderDescription: action.desc, gratuity: action.gratuity};
        case "CHANGE_INPUTS_MODAL_EDIT_ORDER_DESC_GRATUITY":
            return {...state, [action.name]: action.value};
        case "CHANGE_GRATUITY_MODAL_EDIT_ORDER_DESC_GRATUITY":
            return {...state, gratuity: action.gratuity};
        
        
        // case types.CHANGE_LOADER_LIST_PRODUCTS_MODAL_SHOPPING_CARD:
        //     return {...state, loaderListProducts: action.loaderListProducts};
        
        default:
            return state;
    }
};

export default modalEditOrderDescGratuity;
